<template>
	<div>
		<div class="headwhite">
			<ul class="my_headul">
				<li @click="headliClick(index)" :class="{licur:headIndex==index}" v-for="(item,index ) in list"
					:key="index">
					<span>{{item.name}}</span>
				</li>
			</ul>
			<div class="mt20 ml20">
				<div class="newsbox" v-for="(item,index) in 10 " :key="index">
					<el-image :src="src" fit="cover"></el-image>
					<div class="newsright">
						<h3>系统公告 <span>
								2022/02/23 10:23:33
							</span></h3>
						<div class="d-gray newcons">不是吧不是吧，这么有趣好玩的赛事还有人没参加么？
							中国民生银行「趣玩星球IP原创设计大赛」
							倒计时最后10天！
							IP原创设计or波普艺术涂色，
							双赛道任你挥洒创意灵感，
							获奖作品还有机会在中国民生银行全国主题快闪店亮相，
							所有创作者们，抓紧时间最后冲刺！
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'mynews',
		components: {

		},
		data() {
			return {
				headIndex: 0,
				list: [{
					name: '系统公告'
				}],
				src: '',
			}

		},
		created() {},
		updated() {},
		methods: {

		}
	}
</script>
<style lang="scss" scoped>
	.newsbox+.newsbox {
		margin-top: 20px;
	}

	.newsbox {
		display: flex;

		.el-image {
			width: 60px;
			border-radius: 100%;
			height: 60px;
		}

		.newsright {
			flex: 1;
			margin-left: 20px;

			h3 {
				span {
					font-weight: normal;
					font-size: 14px;
					color: var(--info);
					display: inline-block;
					margin-left: 6px;
				}
			}

			.newcons {
				margin-top: 4px;
				white-space: pre-line;
			}
		}
	}
</style>
